import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-loading-skeleton/dist/skeleton.css";
import "react-toastify/dist/ReactToastify.css";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import "leaflet/dist/leaflet.css";
import { NetworkProvider, useNetwork } from "./context/NetworkProvider";
import { setupInterceptors } from "./apis/axiosInstance";
import { ToastContainer } from "react-toastify";
// const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
// ReactDOM.render(
//   <BrowserRouter basename={baseUrl}>
//     <App />
//   </BrowserRouter>,
//   document.getElementById("root"),
// );
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const AppRoot = () => {
  const { setIsNetworkError } = useNetwork();
  useEffect(() => {
    setupInterceptors(setIsNetworkError);
  }, []);
  return <App />;
};

ReactDOM.render(
  <NetworkProvider>
    <BrowserRouter basename={baseUrl}>
      <AppRoot />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        style={{ width: "250px" }}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </BrowserRouter>
  </NetworkProvider>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
